import { render } from "./app.vue?vue&type=template&id=642ce533"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=642ce533&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script